import { NgModule, Optional, SkipSelf } from "@angular/core";
import { ConfigurationService } from "./configuration.service";
import { StringConfigPipe } from "./string-config.pipe";
import { BooleanConfigPipe } from "./boolean-config.pipe";
import { NumberConfigPipe } from "./number-config.pipe";
import { LocalConfigurationService } from "./local-configuration.service";
import { ConfigurationServiceConstants } from "./configuration-service-constants";
export class ConfigurationModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('ConfigurationModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * Provide the configuration service and the application key used in the configuration context.
     * @param config
     * @return ModuleWithProviders
     */
    static forRoot(config) {
        return {
            ngModule: ConfigurationModule,
            providers: [
                ConfigurationService, LocalConfigurationService,
                { provide: ConfigurationServiceConstants.APPLICATION_KEY, useValue: config.application },
                { provide: ConfigurationServiceConstants.LOCAL_CONFIG_FILE_KEY, useValue: config.localConfigFile },
                { provide: ConfigurationServiceConstants.CONTEXT_NAMES_KEY, useValue: config.contextNames }
            ]
        };
    }
}
ConfigurationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [StringConfigPipe, BooleanConfigPipe, NumberConfigPipe],
                exports: [StringConfigPipe, BooleanConfigPipe, NumberConfigPipe]
            },] },
];
/** @nocollapse */
ConfigurationModule.ctorParameters = () => [
    { type: ConfigurationModule, decorators: [{ type: Optional }, { type: SkipSelf },] },
];
export class ConfigurationConfig {
}
//# sourceMappingURL=configuration.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/configuration/configuration.module.js
// module id = 415
// module chunks = 1